import { dataSender } from '../../../common/utils/router';

export const sendFunc = (
    groupFormData,
    funcs,
    setAllowedSend,
    sendData,
    setGroupFormDataError,
    setAlertData,
    userToken,
    lang,
    message,
    repeat,
    currency,
    token,
    setRequestLoading,
    okButtonLoader
) => {
    const dataToSend =
        groupFormData.current && Object.keys(groupFormData.current).length
            ? Object.keys(groupFormData.current).reduce((accum, key) => {
                  if (funcs[key] && funcs[key].onChange && groupFormData.current[key]) {
                      accum[key] = funcs[key].onChange(groupFormData.current[key], false);
                  } else {
                      accum[key] = groupFormData.current[key];
                  }
                  return accum;
              }, {})
            : groupFormData.current;
    let modernDataToSend = {};
    Object.keys(dataToSend).map((item) => {
        if (item !== 'password' && item !== 'financial_password') {
            modernDataToSend[item] = dataToSend[item];
        } else {
            if (dataToSend[item] !== null) modernDataToSend[item] = dataToSend[item];
        }
    });

    setAllowedSend(false);

    if (okButtonLoader && sendData?.sender) {
        setRequestLoading(true);
    }

    if (sendData?.sender)
        return sendData.sender(modernDataToSend, setAllowedSend, setGroupFormDataError, repeat, setRequestLoading);
    dataSender(
        sendData.url,
        sendData?.method || 'POST',
        modernDataToSend,
        (response) => {
            setGroupFormDataError({});
            if (repeat) {
                repeat();
            } else if (sendData?.afterSenderSuccess) {
                sendData.afterSenderSuccess(setAllowedSend, modernDataToSend, response.data);
            } else {
                setAllowedSend(true);
            }
            if (message?.success === false) {
                return false;
            }
            if (message?.success) {
                setAlertData({ type: 'success', cont: message.success });
            } else {
                setAlertData({
                    type: 'success',
                    cont: true,
                    default: 'success_save_data'
                });
            }
        },
        (data, status, headers) => {
            if (message?.error === false) {
                setAlertData(false);
            }
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            }

            if (data.errors && Object.keys(data.errors).length) {
                setGroupFormDataError(data.errors);
            }

            if (sendData?.afterSenderError) {
                sendData.afterSenderError(data, status, headers, setGroupFormDataError, setAllowedSend);
            } else {
                setAllowedSend(true);
            }
        },
        token ? token : userToken,
        sendData?.lang || lang,
        currency,
        sendData?.dataType || 'json',
        sendData?.imageAttrs
    );
};
